import React from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import ContentLoading from './ContentLoading';

const TaskListContainer = (props) => {
  const { actionItemCollection } = props;

  return (
    <DataContainer
      component={Content}
      componentProps={props}
      loading={!actionItemCollection}
      skeleton={ContentLoading}
    />
  );
};

TaskListContainer.defaultProps = {
  actionItemCollection: null,
};

TaskListContainer.propTypes = {
  actionItemCollection: PropTypes.object,
};

export default TaskListContainer;
